const C = require("../constants");
const initial_data = {open: false, partial_open_box:{id:null, amount:0,}};

function partialOpenBoxDialogReducer(state = initial_data, action) {
    switch (action.type) {
        case C.PARTIAL_OPEN_BOX_DIALOG:
            return action.data;
        default:
            return state;
    }
}

export default partialOpenBoxDialogReducer;


// WEBPACK FOOTER //
// ./src/reducers/PartialOpenBoxDialogReducer.js